import { Flex, Text } from '@chakra-ui/react'
import { useLingui } from '@lingui/react/macro'
import type { FC } from 'react'

import { SingleConversation } from './SingleConversation'
import type { Conversation } from './usePreviousInteractions'

type Props = { date: string; conversations: Conversation[] | undefined }

export const Conversations: FC<Props> = ({ conversations, date }) => {
  const { i18n } = useLingui()
  if (!conversations) return null

  return (
    <Flex
      gap="2"
      flexDir="column"
      width="clamp(240px, 800px, 100%)"
      alignItems="center"
    >
      {conversations
        .toReversed()
        .map(
          (c) =>
            c.aiInsights.customSummary && (
              <SingleConversation
                user={c.user}
                dateTime={c.dateTime}
                duration={c.duration}
                subject={c.subject}
                customSummary={c.aiInsights.customSummary}
                conversationUid={c.uid}
                key={c.uid}
                team={c.team}
                keyTopic={c.aiInsights.keyTopic}
                subKeyTopic={c.aiInsights.keySubTopic}
                rootCause={c.aiInsights.rootCause}
              />
            ),
        )}
      <Flex py="2" alignItems="center" justifyContent="center">
        <Text px="4" whiteSpace="nowrap" fontSize="sm" textColor="textMuted">
          {i18n.date(date, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </Text>
      </Flex>
    </Flex>
  )
}
